import axios from "axios";
const hostMap = {
  // "picwish.test": "https://devgw.aoscdn.com/tech/",
  // "dev-picwish-cn.aoscdn.com": "https://devgw.aoscdn.com/tech/",
  "dev-picwish-com.aoscdn.com": "https://devgw.aoscdn.com/tech/",
  "picwish.cn": "https://aw.aoscdn.com/tech/",
  "picwish.com": "https://gw.aoscdn.com/tech/",
};
function getEndpoint() {
  return hostMap[window.location.host] || "https://aw.aoscdn.com/tech/";
}

const service = axios.create({
  baseURL: getEndpoint(),
  timeout: 15000,
});
service.defaults.headers.common["X-API-KEY"] = "wxdoddlor1wuizo1y";

export default service;
